/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateInfluencerRequestViewModel } from "../types/CreateInfluencerRequestViewModel.ts";

export const createInfluencerRequestViewModelSchema = z.object({
  name: z.string().describe("Nome do influenciador.").nullish(),
  email: z.string().describe("Endereço de e-mail do influenciador.").nullish(),
  affiliateCode: z
    .string()
    .describe(
      "Código de afiliado do influenciador. Gerado automaticamente quando não informado. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<CreateInfluencerRequestViewModel>;
